<template>
  <div @change="validateSection">
    <transition-group name="fade" :duration="{enter: 200, leave: 150}">
      <header :key="1">
        <h3>Delivery</h3>
      </header>

      <div class="content" :key="2">
        <div class="form__row--x">
          <label>Delivery Date</label>
          <div class="form__row">
            <smd-date-input v-model="deliveryDate"
                            :style="highlightIfError('deliveryDate')"
                            :disabled="isClose"/>
          </div>
        </div>

        <div class="form__row--x">
          <label>Delivery AOG</label>

          <div class="form__row max-AOG">
            <smd-segment type="pill"
                         v-model="deliveryAOGType"
                         :items="$options.aogTypes()"
                         :disabled="isClose"/>
          </div>
          <div class="form__row max-AOG" v-if="showExactAOG">
            <div class="smd-input-label">
              Weeks
              <input type="number" min="0" v-model="deliveryWeeks"
                     :style="highlightIfError('deliveryWeeks')"
                     :disabled="isClose"/>
            </div>
            <div class="smd-input-label">
              Days
              <input type="number" min="0" v-model="deliveryDays"
                     :style="highlightIfError('deliveryDays')"
                     :disabled="isClose"/>
            </div>
          </div>
          <div class="form__row" v-else>
            <div class="form__row__item">
              <label>Estimated AOG:</label>
              <select v-model="deliveryAOG"
                      :style="highlightIfError('deliveryAOG')"
                      :disabled="isClose">
                <option v-for="mode in $options.aogRanges()"
                        :value="mode.id"
                        :key="mode.id">
                  {{ mode.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="form__row--x" >
          <label>Induced Labor</label>
          <smd-segment type="pill"
                       v-model="isInduced"
                       :items="$options.presenceChoices"
                       :disabled="isClose"/>
        </div>

        <div class="form__row--x" v-if="isInduced">
          <label>Indication for Induction of Labor</label>
          <select v-model="inducedIndication"
                  :style="highlightIfError('inducedIndication')"
                  :disabled="isClose">
            <option v-for="mode in $options.inducedIndicationChoices()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>

        <div class="form__row--x" v-if="isInduced">
          <label>Method for Induction of Labor</label>
          <select v-model="inducedMethod"
                  :style="highlightIfError('inducedMethod')"
                  :disabled="isClose">
            <option v-for="mode in $options.inducedMethodChoices()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>

        <div class="form__row--x" v-if="isInduced">
          <label>Problems arising from Induced Labor</label>
          <select v-model="inducedComplication"
                  :style="highlightIfError('inducedComplication')"
                  :disabled="isClose">
            <option v-for="mode in $options.inducedComplicationChoices()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>

        <div class="form__row--x">
          <label>Did patient undergo TOLAC?</label>
          <div :style="highlightIfError('isTOLAC')">
            <smd-segment type="pill"
                         v-model="isTOLAC"
                         :items="$options.booleanChoices"
                         :disabled="isClose"/>
          </div>
        </div>

        <pogs-delivery-manner  :is-tolac="isTOLAC"></pogs-delivery-manner>

      </div>
    </transition-group>
  </div>
</template>

<script>
  import withSectionValidation from '../../../mixins/with-section-validation'
  import validations from '../../../validations/pregnancy-postpartum-section-validations'
  import withErrorValidation from '../../../mixins/with-error-validation-mixin';

  import PogsDeliveryManner from './pogs-form__item--pregnancy--deliverymanner';

  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import {
    fn_getNameWithMap, ObjectModelToArrayModel,
    smdSelectModelReducer, injectCategoryIdToConditions, categorizeAOG, injectDisabledProperty
  }
    from "../../../utilities/utilityOperators";

  import {
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD,
    GETTER_PREGNANCY_INDICATION,
    ACTION_UPDATE_PREGNANCY_INDICATION,
    MUTATE_REMOVE_PREGNANCY_INDICATION,
    ACTION_UPDATE_MORBIDITY,
    MUTATE_REMOVE_MORBIDITY,
  } from '../../../store/forms/case-form-state'

  import {
    getMapFn,
    REF_MATERNAL_FETAL_FORM_DELIVERY,
    REF_MATERNAL_FETAL_FORM_CONCOMITANT_PROCEDURES,
    REF_MATERNAL_FETAL_FORM_INDICATIONS_CS,
    REF_MATERNAL_FETAL_FORM_INDICATION_FORCEPS,
    REF_MATERNAL_FETAL_FORM_INDICATION_VACUUM,
    REF_MATERNAL_FETAL_FORM_INDICATIONS_CS_OBJ,
    REF_MATERNAL_FETAL_FORM_INDICATION_FORCEPS_OBJ,
    REF_MATERNAL_FETAL_FORM_INDICATION_VACUUM_OBJ,
    REF_MATERNAL_FETAL_FORM_PRIMARY_REPEAT,
    REF_MATERNAL_FETAL_FORM_INCISION,
    REF_MATERNAL_FETAL_FORM_MORBIDITIES,
    REF_MATERNAL_FETAL_FORM_MORBIDITIES_CONDITIONS_OBJ,
    REF_AOG_TYPES,
    REF_AOG_RANGES,
    REF_INDUCED_INDICATION,
    REF_INDUCED_METHOD,
    REF_INDUCED_COMPLICATION,
  } from '../../../store/modules/referencedata2'

  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  export default {
    mixins: [withSectionValidation, withErrorValidation],
    components: {PogsDeliveryManner},
    computed: {
      ...mapGetters({
        deliveryIndications: GETTER_PREGNANCY_INDICATION,

      }),
      ...mapFields([
        'isPregnancy',
        'isDelivered',
        'isTOLAC',

        'pregnancyType',
        'deliveryAOG',
        'deliveryAOGType',
        'deliveryDate',
        'deliveryWeeks',
        'deliveryDays',
        'deliveryManner',
        'primaryRepeat',

        // Added tagging of procedure
        'CSBilateralSalpingectomy',
        'CSBTL',
        //Induction of Labor
        'isInduced',
        'inducedIndication',
        'inducedMethod',
        'inducedComplication',
        'returnToOR',

        'incision',
        'deliveryIndication',
        'concomitantProcedure',
        'morbidities',
        'motherCondition',
        'deathReviewed',
        'isClose'
      ]),
      isCS() {
        let list = [1];
        return !!list.includes(this.deliveryManner)
      },
      isForceps() {
        let list = [5];
        return !!list.includes(this.deliveryManner)
      },
      isVacuum() {
        let list = [6];
        return !!list.includes(this.deliveryManner)
      },
      willShowNumberOfInfants() {
        return this.pregnancyType !== 1
      },
      willShowIndication() {
        return this.isCS || this.isForceps || this.isVacuum
      },
      computedPregnancyType: {
        get() {
          return this.pregnancyType
        },
        set(value) {
          this.pregnancyType = value;
          // Assume that 1 is for singleton pregnancy reference
          this.computedInfantsNumber = value === 1 ? 1 : 2
        }
      },
      deliveryIndicationsLookup() {
        let mapFnName = null;

        if (this.isCS)
          mapFnName = REF_MATERNAL_FETAL_FORM_INDICATIONS_CS;
        else if (this.isForceps)
          mapFnName = REF_MATERNAL_FETAL_FORM_INDICATION_FORCEPS;
        else if (this.isVacuum)
          mapFnName = REF_MATERNAL_FETAL_FORM_INDICATION_VACUUM;

        return mapFnName ? injectDisabledProperty(getMapFn(mapFnName)()) : [];
      },
      deliveryIndicationsLookupObj() {
        let mapFnName = null;

        //TODO maybe a singular object for indication types regardless of  deliveryManner
        if (this.isCS)
          mapFnName = REF_MATERNAL_FETAL_FORM_INDICATIONS_CS_OBJ;
        else if (this.isForceps)
          mapFnName = REF_MATERNAL_FETAL_FORM_INDICATION_FORCEPS_OBJ;
        else if (this.isVacuum)
          mapFnName = REF_MATERNAL_FETAL_FORM_INDICATION_VACUUM_OBJ;

        return mapFnName ? getMapFn(mapFnName)() : {};
      },
      hasIndications() {
        return !!Object.keys(this.deliveryIndications || {}).length;
      },
      showMorbidities() {
        return !!Object.keys(this.morbidities || {}).length;
      },
      showExactAOG() {
        return this.deliveryAOGType === 1;
      },
      morbiditiesModel: {
        get() {
          return ObjectModelToArrayModel(this.morbidities, getMapFn(REF_MATERNAL_FETAL_FORM_MORBIDITIES_CONDITIONS_OBJ))
        },
        set(v) {
          const model = v.reduce(smdSelectModelReducer, {});
          this.doUpdateMorbiditiesModel(model)
        }
      },
      deliveryIndicationsModel: {
        get() {
          const map = this.deliveryIndicationsLookupObj;
          if(this.hasIndications && Object.keys(map).length > 0) {
            const keys = Object.keys(this.deliveryIndications);

            return keys.map((v) => ({
              id: map[v].id,
              name: fn_getNameWithMap(map)(v)
            }));
          }

          return [];
        },
        set(v) {
          let value = {};
          if(v instanceof Array && v.length) {
            value = v.reduce((acc, o) => {
              acc[o.id] = {id: o.id};
              return acc;
            }, {})
          }
          this.doUpdateMultiSelectModel(value);
        }
      },
      morbiditiesLookup() {
        return injectCategoryIdToConditions(getMapFn(REF_MATERNAL_FETAL_FORM_MORBIDITIES))()
      }
    },
    methods: {
      ...mapActions({
        doUpdateMultiSelectModel: ACTION_UPDATE_PREGNANCY_INDICATION,
        doUpdateMorbiditiesModel: ACTION_UPDATE_MORBIDITY
      }),
      ...mapMutations({
        removeIndication: MUTATE_REMOVE_PREGNANCY_INDICATION,
        removeMorbidity: MUTATE_REMOVE_MORBIDITY
      }),
      addConcomittant(e) {
        this.$emit('addConcomittant', e)
      },
      decodeIndication(id) {
        const o = this.deliveryIndicationsLookupObj[id];
        return o ? o.name : "";
      },
      checkForErrors(errors) {
        return Object.keys(this.$options.validations).reduce( (acc, key) => {
          if (key !== 'neonatal') {
            return acc || errors[key].$error;
          } else {
            return acc;
          }
        }, false);
      },
    },
    aogTypes: getMapFn(REF_AOG_TYPES),
    aogRanges: getMapFn(REF_AOG_RANGES),
    deliveryManners: getMapFn(REF_MATERNAL_FETAL_FORM_DELIVERY),
    concomitantProcedures: getMapFn(REF_MATERNAL_FETAL_FORM_CONCOMITANT_PROCEDURES),
    primaryOrRepeat: getMapFn(REF_MATERNAL_FETAL_FORM_PRIMARY_REPEAT),
    incisions: getMapFn(REF_MATERNAL_FETAL_FORM_INCISION),
    inducedIndicationChoices: getMapFn(REF_INDUCED_INDICATION),
    inducedMethodChoices: getMapFn(REF_INDUCED_METHOD),
    inducedComplicationChoices: getMapFn(REF_INDUCED_COMPLICATION),
    presenceChoices: [
      {id: 1, name: 'WITH', val: true},
      {id: 2, name: 'WITHOUT', val: false}
    ],
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ],
    validationSection: 'pregnancy',
    watch :{
      deliveryAOGType() {
        this.deliveryAOG = categorizeAOG(this.deliveryWeeks);
      },
      deliveryWeeks(val) {
        this.deliveryAOG = categorizeAOG(val);
      },
      deliveryManner(newVal, oldVal) {
        // Always reset the indications list once the mode of delivery changes
        if (newVal !== oldVal)
          this.deliveryIndicationsModel = [];
      },
    },
    validations
  }
</script>

<style scoped lang="scss">
  @import "../../../scaffolding/scss/pogs-util";

  .max-AOG{
    input{
      max-width: 115px;
    }
  }
</style>
